import { FC, useState } from "react";
import { FaRegCircleUser } from "react-icons/fa6";
import { ImSpinner8 } from "react-icons/im";
import { MdCardGiftcard, MdLogout, MdOutlineLibraryBooks, MdOutlinePassword } from "react-icons/md";
import { PiNotepad, PiUserCircleLight } from "react-icons/pi";
import { SlSettings } from "react-icons/sl";
import { useLocation } from "react-router";
// import { MdKeyboardArrowUp, MdKeyboardArrowDown } from "react-icons/md";
import { BiSolidUpArrow } from "react-icons/bi";

import { motion } from "framer-motion";
import { useLanguageParams } from "~/hook/useLanguageParams";
import useLocale from "~/hook/useLocale";
import { removeItemFromLocalStorage, removeUserLoginKeyFromLocalStorage } from "~/lib/helperFuncation/localStorageService";
import { removeSession } from "~/lib/helperFuncation/sessionStorageService";
import { logoutThunk, setAuthToken, setNavigatTo } from "~/lib/store/slice/loginSlice";
import { useAppDispatch, useAppSelector } from "~/lib/store/store";
import { AUTH_COOKIE_TOKEN, COLORS, FCM_TOKEN, QUIZ_COMPLETED, QUIZ_SESSION_KEY, USER_PROFILE_DATA } from "~/utils/constant";
import { deleteCookie, getCookie } from "~/utils/cookies";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../ui/dropdown-menu";

const iconMap = {
  MdOutlineLibraryBooks: MdOutlineLibraryBooks,
  FaRegCircleUser: FaRegCircleUser,
  SlSettings: SlSettings,
  MdLogout: MdLogout,
  MdOutlinePassword: MdOutlinePassword,
  MdCardGiftcard: MdCardGiftcard,
  PiNotepad: PiNotepad,
};

type IconKey = keyof typeof iconMap;

interface DropDownOption {
  name: string;
  navigateTo: string;
  icon: IconKey;
}

type PropsType = {
  isFooter?: boolean;
  isDisplayLoggingIcon?: boolean;
};

const ProfileComponent: FC<PropsType> = ({ isFooter = false, isDisplayLoggingIcon = true }) => {
  const { navigate } = useLocale();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const lang = useLanguageParams();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { isLogoutLoading } = useAppSelector((state) => state.login);

  const DropDownOptions: DropDownOption[] = [
    // {
    //   name: "My Library",
    //   navigateTo: "/library",
    //   icon: "MdOutlineLibraryBooks",
    // },
    {
      name: "Profile",
      navigateTo: "/profile",
      icon: "FaRegCircleUser",
    },

    // {
    //   name: "My Family",
    //   navigateTo: "/my-family",
    //   icon: "FaRegCircleUser",
    // },
    {
      name: "Thal Bhet",
      navigateTo: "/thalbhet",
      icon: "MdCardGiftcard",
    },
    {
      name: "Registration",
      navigateTo: "/registration",
      icon: "PiNotepad",
    },
    {
      name: "Settings",
      navigateTo: "/setting",
      icon: "SlSettings",
    },
    {
      name: "Logout",
      navigateTo: "/logout",
      icon: "MdLogout",
    },
  ];

  const handleItemClick = async (navigateTo: string) => {
    const token = getCookie(AUTH_COOKIE_TOKEN) || null;
    dispatch(setAuthToken(token));
    if (navigateTo === "/logout") {
      // Don't close dropdown immediately for logout
      const response = await dispatch(logoutThunk());
      if (logoutThunk.fulfilled.match(response)) {
        // API succeeded - only then remove cookies and local data
        removeUserLoginKeyFromLocalStorage();
        removeItemFromLocalStorage(USER_PROFILE_DATA);
        removeSession(QUIZ_SESSION_KEY);
        removeSession(QUIZ_COMPLETED);
        deleteCookie(AUTH_COOKIE_TOKEN);
        deleteCookie(FCM_TOKEN);
        dispatch(setNavigatTo(null));
        setIsDropdownOpen(false);
        navigate(`/`);
      } else {
        // API failed - keep cookies and data intact
        console.error("Logout failed - cookies and data preserved");
        setIsDropdownOpen(false);
        // Optionally show error message to user
      }
    } else if (token !== null) {
      // Close dropdown immediately for other navigation items
      setIsDropdownOpen(false);
      navigate(navigateTo);
    }
  };

  const handleDropdownOpenChange = (open: boolean) => {
    // Prevent closing dropdown while logout is in progress
    if (!open && isLogoutLoading) {
      return;
    }
    setIsDropdownOpen(open);
  };

  // Handle scroll lock when dropdown opens
  // useEffect(() => {
  //   const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  //   if (isDropdownOpen) {
  //     document.body.style.overflow = "hidden";
  //     document.body.style.paddingRight = `${scrollbarWidth}px`;
  //   } else {
  //     document.body.style.paddingRight = `${scrollbarWidth}px`;
  //   }

  //   return () => {
  //     document.body.style.overflow = "";
  //     document.body.style.paddingRight = "";
  //   };
  // }, [isDropdownOpen]);

  return (
    // <div className="size-10 rounded-full flex justify-center items-center cursor-pointer">
    // {/* </div> */}
    <>
      <DropdownMenu modal={false} open={isDropdownOpen} onOpenChange={handleDropdownOpenChange}>
        {isDisplayLoggingIcon && (
          <DropdownMenuTrigger className="relative outline-none ring-0 border-none">
            <PiUserCircleLight color={isFooter ? COLORS.white : COLORS.iconOrange} size={35} className="cursor-pointer ring-0" />

            {isDropdownOpen ? (
              <motion.div
                initial={{ opacity: 0, y: 2 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.2 }}
                exit={{ opacity: 0, y: 2 }}
                className="absolute -bottom-1.5 right-3 translate-x-1/4 translate-y-1/4  rounded-full"
              >
                <BiSolidUpArrow color={isFooter ? COLORS.white : COLORS.iconOrange} size={10} />
              </motion.div>
            ) : null}
          </DropdownMenuTrigger>
        )}
        <DropdownMenuContent
          className="w-auto bg-gradient-to-br from-white to-cardBg border rounded-xl border-default-200 relative overflow-hidden"
          align="end"
        >
          {DropDownOptions.map(({ name, navigateTo, icon }) => {
            const IconComponent = iconMap[icon];
            const isLogout = navigateTo === "/logout";
            const showSpinner = isLogout && isLogoutLoading;

            return (
              <DropdownMenuItem
                key={name}
                onClick={() => handleItemClick(navigateTo)}
                disabled={showSpinner}
                className="hover:!bg-cardBg w-full flex justify-start items-center gap-2 text-textColor font-inter font-medium capitalize rounded-xl cursor-pointer disabled:opacity-70 disabled:cursor-not-allowed"
              >
                {showSpinner ? (
                  <ImSpinner8 className="text-base text-textColor animate-spin" />
                ) : (
                  IconComponent && <IconComponent className="text-xl text-textColor ring-0 outline-none border-none" />
                )}
                <span className="text-textColor text-14 font-inter font-normal">{name}</span>
              </DropdownMenuItem>
            );
          })}
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
};

export default ProfileComponent;
